import React from "react";

// Import Components
import Navbar from "../components/Navbar";
import Home from "../components/Home";
import About from "../components/About";
import Services from "../components/Services";
import Work from "../components/Work";
import Contact from "../components/Contact";

function HomePage() {
  return (
    <div>
      <Navbar />
      <Home />
      <About />
      <Services />
      <Work />
      <Contact />
    </div>
  );
}

export default HomePage;
